import { TwoUIProgressView, TwoUIProgressViewOperationData } from "@amx/ux-twoui-telemetry";
import React from "react";
import { Spinner, SpinnerProps } from "../../../Spinner/Spinner";

export interface ListItemColumnOperationalData {
    /**
     * Information about the monitored operation.
     */
    readonly operationData: TwoUIProgressViewOperationData;

    /**
     * Spinner component properties to generate a spinner.
     */
    readonly spinnerProps: SpinnerProps;
}

export interface OperationalContentProps {
    /**
     * Operational data for ListItemColumn components.
     */
    readonly operationalData?: ListItemColumnOperationalData;
}

export const OperationalContent: React.FC<OperationalContentProps> = ({
    operationalData,
    children
}) => {
    const content: React.ReactElement = <>{children}</>;

    if (operationalData) {
        return (
            <TwoUIProgressView
                operationData={operationalData.operationData}
                updatingView={<Spinner {...operationalData.spinnerProps} />}
                finishedView={content}
                inertView={content}
            />
        );
    } else {
        return content;
    }
};
